export const statsMapping = ({ locales }) => ({
  aggression: locales["behaviour.stats.aggression"],
  apperception: locales["behaviour.stats.apperception"],
  candor: locales["behaviour.stats.candor"],
  charm: locales["behaviour.stats.charm"],
  coordination: locales["behaviour.stats.coordination"],
  courage: locales["behaviour.stats.courage"],
  cruelty: locales["behaviour.stats.cruelty"],
  curiosity: locales["behaviour.stats.curiosity"],
  decisiveness: locales["behaviour.stats.decisiveness"],
  empathy: locales["behaviour.stats.empathy"],
  humility: locales["behaviour.stats.humility"],
  humor: locales["behaviour.stats.humor"],
  imagination: locales["behaviour.stats.imagination"],
  loyalty: locales["behaviour.stats.loyalty"],
  meekness: locales["behaviour.stats.meekness"],
  patience: locales["behaviour.stats.patience"],
  selfPreservation: locales["behaviour.stats.selfPreservation"],
  sensuality: locales["behaviour.stats.sensuality"],
  tenacity: locales["behaviour.stats.tenacity"],
  vivacity: locales["behaviour.stats.vivacity"],
});

export const computeStats = ({ host, locales }) =>
  Object.keys(statsMapping({ locales })).map((statKey) => ({
    category: statsMapping({ locales })[statKey],
    value: host?.[statKey] || 0,
  }));

export const getStatPropFromLabel = ({ category, locales }) =>
  Object.entries(statsMapping({ locales })).find(
    ([stat, label]) => label === category
  )?.[0];
